import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
}
export function SectionHeading({
  title,
  subtitle,
  centered = false
}: SectionHeadingProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5
  }} className={centered ? 'text-center' : ''} data-id="element-425">
      <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-3" data-id="element-426">
        {title}
      </h2>
      <div className="w-16 h-1 bg-au-gold mb-4" style={{
      marginLeft: centered ? 'auto' : '0',
      marginRight: centered ? 'auto' : '0'
    }} data-id="element-427"></div>
      {subtitle && <p className="text-lg text-gray-600 max-w-2xl" style={{
      marginLeft: centered ? 'auto' : '0',
      marginRight: centered ? 'auto' : '0'
    }} data-id="element-428">
          {subtitle}
        </p>}
    </motion.div>;
}